/* eslint-disable no-case-declarations */
import * as types from 'root/language/languageActions';
import { SupportedLocale } from 'types';
import { REHYDRATE } from 'redux-persist';

// use detectBrowserLanguage() when going international?

export type UserLanguageState = {
    userLanguage: SupportedLocale,
    error: any
}

const defaultState: UserLanguageState = {
    userLanguage: 'nl', // the language used when not loggedIn
    error: null
};

export default function userLanguage(state: UserLanguageState = defaultState, action: any): UserLanguageState {
    switch (action.type) {
        case types.LANGUAGE_UPDATE_START:
            return {
                ...state,
                error: null
            };

        case types.LANGUAGE_UPDATE_COMPLETED:
            return {
                ...state,
                userLanguage: action.payload.userLanguage
            };

        case types.LANGUAGE_UPDATE_ERROR:
            return {
                ...state,
                error: action.error
            };

        case REHYDRATE:
            let incoming = action.payload && action.payload.userLanguage;
            return {
                ...state,
                ...incoming
            };

        default:
            return state;
    }
}
